(() => {
  const sticky = document.querySelector('[data-valora-adv-nurse-sticky]');
  if (!sticky) return;
  const sidebar = document.querySelector('.valora-adv-nurse__aside');
  const reviews = document.querySelector('.valora-adv-nurse-reviews');
  const reviewFeed = reviews?.querySelector('.valora-adv-nurse-reviews__feed');
  const reviewLoading = reviews?.querySelector('.valora-adv-nurse-reviews__loading');
  const reviewSources = reviewFeed ? Array.from(reviewFeed.querySelectorAll('[data-valora-review-base]')) : [];
  let loadingReviews = false;
  const revealReviews = () => {
    if (!reviewFeed || !reviewLoading || !reviewSources.length || loadingReviews) return;
    if (reviewFeed.getBoundingClientRect().bottom > window.innerHeight + 500) return;
    loadingReviews = true;
    reviewLoading.classList.add('is-loading');
    window.setTimeout(() => {
      const order = [...reviewSources];
      for (let i = order.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [order[i], order[j]] = [order[j], order[i]];
      }
      const batch = document.createDocumentFragment();
      order.forEach((source) => {
        const card = source.cloneNode(true);
        card.removeAttribute('data-valora-review-base');
        card.removeAttribute('data-shopify-editor-block');
        batch.appendChild(card);
      });
      reviewFeed.appendChild(batch);
      reviewLoading.classList.remove('is-loading');
      loadingReviews = false;
    }, 300);
  };
  const toggle = () => {
    sticky.classList.toggle('is-visible', window.scrollY > Math.max(700, window.innerHeight));
    if (sidebar && reviews) sidebar.classList.toggle('is-hidden-after-story', reviews.getBoundingClientRect().top <= window.innerHeight);
    revealReviews();
  };
  window.addEventListener('scroll', toggle, { passive: true });
  toggle();
})();

